// Packages
import React from "react";

// Components
import useComponents from "../../../components";

// Controllers
import useControllers from "../../../../controllers";

const RolesView = () => {
  const {
    ContentWrappers,
    TableContent,
    TableRow,
    useButtons,
    Pagination,
    TextFieldSeach,
    Typography,
    useModals,
    Dropdown,
  } = useComponents();

  const { DefaultButton } = useButtons();
  const { DefaultModal } = useModals();

  const { useScreenHooks } = useControllers();
  const { useRoles } = useScreenHooks();
  const { useRolesView } = useRoles();
  const {
    control,
    listRoles,
    handleCreateNewRole,
    handleEditRole,
    paginationSettings,
    handlePagination,
    onChangeSearch,
    handleDeleteRole,
    modalDelete,
    handleCloseModal,
    handleConfirmDelete,
  } = useRolesView();

  return (
    <ContentWrappers gridColums={["1fr"]} className="max-w-screen-2xl w-11/12" as="section">
      <div className="bg-white px-8 pt-10 pb-12 rounded-lg">
        <ContentWrappers gridColums={["1fr 1fr"]} className="mb-10">
          <TextFieldSeach
            placeholder="Buscar"
            name="search"
            id="search"
            control={control}
            onInputChange={onChangeSearch}
          />
          <div className="flex justify-end">
            <DefaultButton color="secondary" onClick={handleCreateNewRole}>
              Crear Rol
            </DefaultButton>
          </div>
        </ContentWrappers>
        <TableContent
          headerCellList={["Id", "Nombre", "Acciones"]}
          gridCell={["0.5fr", "2fr", "66px"]}
        >
          {listRoles.map((role, index) => {
            return (
              <TableRow key={index}>
                <div>{role?.id}</div>
                <div>
                  <b>{role?.name}</b>
                </div>
                <div className="flex justify-end">
                  <Dropdown
                    options={[
                      { id: 'edit', action: () => handleEditRole(role) },
                      { id: 'delete', action: () => handleDeleteRole(role.id, role.name) },
                    ]}
                  />
                </div>
              </TableRow>
            );
          })}
        </TableContent>
      </div>
      <Pagination onPageChange={handlePagination} pageCount={paginationSettings.totalPages} />
      <DefaultModal isOpen={modalDelete.show}>
        <div className="flex items-center flex-col space-y-8">
          <Typography variant="body2" className="text-center">
            ¿Está seguro de eliminar el rol <b>{modalDelete.name}</b>?
          </Typography>
          <div className="flex items-center space-x-4">
            <DefaultButton color="secondary" onClick={handleCloseModal}>
              Cancelar
            </DefaultButton>
            <DefaultButton color="success" onClick={handleConfirmDelete}>
              Aceptar
            </DefaultButton>
          </div>
        </div>
      </DefaultModal>
    </ContentWrappers>
  );
};

export default RolesView;
